import { Slot } from '@radix-ui/react-slot';

import { type TextProps } from './types';

const Text = (props: TextProps) => {
  const { children, asChild = false, as: Tag = 'span', ...textProps } = props;

  return (
    <Slot {...textProps}>{asChild ? children : <Tag>{children}</Tag>}</Slot>
  );
};

export { Text };
